import { Form, Input, Select } from "antd";
import FormBox from "../../Atoms/FormBox/FormBox";
import FormTitle from "../../Atoms/FormTitle/FormTitle";
import InputFormContainer from "../../Atoms/InputFormContainer/InputFormContainer";
import Modal from "../Modal/Modal";
import { useModal } from '../../../customHooks/useModal'
import iconProfileCreate from '../../../assets/iconProfileCreate.svg'
import Button from "../../Atoms/Button/Button";
import { useLocation } from "wouter";
import './FormProfileCreate.scss'
const { Option } = Select;


const FormProfileCreate = ({ handleModalCreationMasiva }) => {
  const [isOpenModal, openModal, closeModal] = useModal(false)
  const [form] = Form.useForm();
  const [, setLocation ] = useLocation();

  const sendForm = (e) => {
    console.log(e); // Aqui el objeto con los valores del formulario
    openModal(true) // Si se envia el formulario correctamente, se muestra el modal
  };

  const clearForm = () => {
    form.resetFields()
    closeModal()
  }

  const goToDashboard = () => {
    closeModal()
    setLocation('/dashboard')
  }

  return (
    <>
    <Form onFinish={sendForm} form={form} >
      <FormBox>
        <FormTitle text="Datos del Usuario" />

        <InputFormContainer label="Nombre:" indentificador="nombre">
          <Form.Item
            name="nombre"
            rules={[{ required: true, message: "Por favor ingresa tu nombre" }]}
          >
            <Input size="large" placeholder="José Alejandro" />
          </Form.Item>
        </InputFormContainer>

        <InputFormContainer label="Apellido:" indentificador="apellido">
          <Form.Item
            name="apellido"
            rules={[
              { required: true, message: "Por favor ingresa tu apellido" },
            ]}
          >
            <Input size="large" placeholder="Gonzáles" />
          </Form.Item>
        </InputFormContainer>

        <InputFormContainer label="Email personal:" indentificador="email">
          <Form.Item
            name="email"
            rules={[{ required: true, message: "Por favor ingresa tu email" }]}
          >
            <Input size="large" placeholder="user@gmail.com" />
          </Form.Item>
        </InputFormContainer>

        <InputFormContainer label="Móvil:" indentificador="movil">
          <div className="main-input-number">
            <div className="main-input-number_code"> 
              <Select size="large" placeholder="VE +58">
                <Option value="VE +58">VE +58</Option>
              </Select>
            </div>
            <div className="main-input-number_number">
              <Form.Item name="mainPhoneNumber" hasFeedback rules={[{validator:(_, value)=> value?value.length === 10 ? !isNaN(value)?Promise.resolve():Promise.reject('Este campo debe ser numerico'):Promise.reject("Número incompleto"):Promise.reject('Por favor ingresa tu movil')},{required: true, message: ' '}]}>
                <Input  size="large" maxLength={10} placeholder="0123456789" name="mainPhoneNumber" className="text-input"  />
              </Form.Item>
            </div>
          </div>
        </InputFormContainer> 

        <InputFormContainer spanTwo label="Tipo de rol (puedes asignar más de uno):" indentificador="type">
          <Form.Item
            name="type"
            rules={[{ required: true, message: "Por favor ingrese Tipo de rol" }]}
          >
            <Select placeholder="Tipo de rol" mode="multiple" size="large">
              <Select.Option value="Administrativo" key={1}>
                Administrativo
              </Select.Option>
              <Select.Option value="Funcional" key={2}>
                Funcional
              </Select.Option>
              <Select.Option value="Agente" key={3}>
                Agente
              </Select.Option>
            </Select>
          </Form.Item>
        </InputFormContainer>
        
        <div className="associate-profile-header_buttons m-cols-2">
          <div className="header-buttons_one">
            <span className="button primary s-large m-auto" onClick={() => handleModalCreationMasiva()}>Creacion masiva</span>
          </div>
          <div className="header-buttons_two">
            <Button content="Crear perfil" customClass="s-large m-auto" type="primary" />
          </div>
        </div>

      </FormBox>
    </Form>

    <Modal 
      isOpenModal={isOpenModal} 
      iconModal={iconProfileCreate}
      titleModal="Perfil creado" 
      closeModal={() => closeModal()}
      subTitleModal="Se ha creado con éxito el nuevo perfil, un email será enviado para activar la cuenta.">    
       <div className="mt-20 buttons-container center">
          <Button content="Crear otro perfil" type="primary" customClass="s-large m-auto" clickHandler={clearForm}/>
          <Button content="Ir al dashboard" type="primary outline" customClass="s-large m-auto" clickHandler={() => goToDashboard()} />
       </div>
    </Modal>    
    </>
  );
};

export default FormProfileCreate;
